import { useEffect, useRef, memo } from "react";

function TopStories({ theme }) {
  const container = useRef();

  useEffect(() => {
    if (!container.current || !theme) return;

    const timeout = setTimeout(() => {
      container.current.innerHTML = "";

      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-timeline.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
      {
        "displayMode": "compact",
        "feedMode": "market",
        "colorTheme": "${theme}",
        "isTransparent": ${theme === "dark"},
        "locale": "en",
        "market": "crypto",
        "width": "100%",
        "height": 450
      }
    `;
      if (container.current) {
        container.current.appendChild(script);
      }
    }, 0);
    return () => clearTimeout(timeout); // Clean up
  }, [theme]);

  return (
    <div
      className={`w-full rounded-sm border border-background-surface shadow-box-shadow ${
        theme === "dark" ? "bg-[#1a1a1a]" : ""
      }`}
      ref={container}
    >
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
}

export default memo(TopStories);
